/* eslint-disable prettier/prettier */
// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
export const VERSION = {
  "gitBuildGlobalVersion": "1.9.0",
  "gitBuildTime": "2026-11-04T12:19:39.753Z",
  "gitBuildVersion": "1.9.0",
  "gitCommitId": "c8b3360",
  "gitCommitIdFull": "c8b33608b30dfd42d432e9035682ff16ecbbc65f",
  "gitCommitTime": "2026-11-03T20:53:36.000Z",
  "version": "1.9.0-2026-11-03T20:53:36.000Z-(c8b3360)"
};
